import { DomainError } from '../../../../errors';
import { NizzaPlan } from '../entities';

export class AccountNotFoundError extends DomainError {
  constructor(account: string) {
    super('NIZZA_ACCOUNT_NOT_FOUND_ERROR', `Error finding account: ${account}`);
  }
}

export class PlanNotFoundError extends DomainError {
  constructor(planName: string) {
    super('NIZZA_PLAN_NOT_FOUND_ERROR', `Error finding plan: ${planName}`);
  }
}

export class CreatePlanError extends DomainError {
  constructor(data: NizzaPlan) {
    super('NIZZA_CREATE_PLAN_ERROR', `Error creating plan: ${data.plan}`, data);
  }
}
